import { ChainOfFifthsCircle } from "../../Comps/ChainOfFifthsCircle/ChainOfFifthsCircle"
import { ChordShapeHelper } from "../../Comps/ChordShapeHelper/ChordShapeHelper"
import { ChordTypeHelper } from "../../Comps/ChordTypeHelper/ChordTypeHelper"
import { HexKeyHelper } from "../../Comps/HexKeyHelper/HexKeyHelper"
import { HexPattern } from "../../Comps/HexPattern/HexPattern"
import { IntervalNames } from "../../Comps/IntervalNames/IntervalNames"
import { KeyCompass } from "../../Comps/KeyCompass/KeyCompass"
import { ModalPositions } from "../../Comps/ModalPositions/ModalPositions"
import { ModeHelper } from "../../Comps/ModeHelper/ModeHelper"
import { CircleOfFifths, NoteCircle } from "../../Comps/NoteCircle/NoteCircle"

export interface HelperConfig{
    title:string,
    element:React.ReactNode,
    displayOrder:number
}
export class Helpers{
    static MusicalAlphabet:string = 'The Musical Alphabet'
    static IntervalNames:string = 'Interval Names'
    static HexPattern:string = 'The Hex Pattern'
    static HexKeyHelper:string = "The Hex Key"
    static KeyCompass:string = 'The Key Compass'
    static ChordTypes:string = 'Chord Types by Position'
    static ChordShapes:string = 'Chord Shapes'
    static ModeNames:string = 'Mode Names'
    static ModalPositions:string = "Modal Positions"
    static getHelpers(){
        const scale:number = 1
        const height:number = 175 * scale
        const width:number = 250 * scale
        const radius:number = 65 * scale
        const helpers:HelperConfig[]= [
            {
                title:Helpers.MusicalAlphabet,
                element:<NoteCircle rotation={90} height={height * 1.3} width={width} radius={radius * 1.3} caption={'clear'}/>,
                displayOrder:0
            },            {
                title:Helpers.IntervalNames,
                element:<IntervalNames/>,
                displayOrder:0
            },
            {
                title:Helpers.HexPattern,
                element:<HexPattern height={height} width={width} radius={radius}/>,
                displayOrder:0
            },
            {
                title:Helpers.HexKeyHelper,
                element:<HexKeyHelper height={height} width={width} radius={radius}/>,
                displayOrder:0
            },
            {
                title:'The Circle of Fifths',
                element:<CircleOfFifths height={height * 1.3} width={width} radius={radius * 1.3}/>,
                displayOrder:0
            },
            {
                title:Helpers.ChordTypes,
                element:<ChordTypeHelper height={height} width={width} radius={radius}/>,
                displayOrder:0
            },
            {
                title:Helpers.ChordShapes,
                element:<ChordShapeHelper height={height} width={width} radius={radius}/>,
                displayOrder:0
            },
            {
                title:Helpers.ModeNames,
                element:<ModeHelper height={height * 1.2} width={width} radius={radius * 1.2}/>,
                displayOrder:0
            },
            {
                title:Helpers.ModalPositions,
                element:<ModalPositions height={height * 1.2} width={width} radius={radius * 1.2}/>,
                displayOrder:0
            },
            {
                title:'Chain of Fifths',
                element:<ChainOfFifthsCircle height={height} width={width} radius={radius * .8}/>,
                displayOrder:0
            },
            {
                title:Helpers.KeyCompass,
                element:<KeyCompass height={height} width={width * 1.2} radius={radius * .5}/>,
                displayOrder:0
            }
        ]
        return helpers
    }
}